<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img
          :src="appLogoImageUrl"
          rounded="circle"
          alt="logo"
        />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{ $t('full.login_welcome', {AppName: appName}) }}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ appTitle }}
            <b-card-text>
              <small>vers. {{ appVersion }}</small>
            </b-card-text>
          </b-card-text>

          <!-- form -->
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent
          >
            <!-- submit buttons -->
            <b-button
              type="submit"
              variant="outline-primary"
              block
              @click="login('aad')"
            >
              <b-img
                class="mr-50"
                :src="require('@/assets/images/icons/microsoft.svg')"
              />
              <span class="align-middle">{{ $t('full.login_microsoft') }}</span>
            </b-button>

            <b-button
              type="submit"
              variant="outline-primary"
              block
              @click="login('google')"
            >
              <b-img
                class="mr-50"

                :src="require('@/assets/images/icons/google.svg')"
              />
              <span class="align-middle">{{ $t('full.login_google') }}</span>
            </b-button>
          </b-form>

          <b-card-text class="text-center mt-2">
            <span>{{ $t('full.login-problem') }}</span>
            <b-link :to="{name: 'logout'}">
              <span>&nbsp;{{ $t('common.click-here') }}</span>
            </b-link>
          </b-card-text>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { $themeConfig } from '@themeConfig'
import {
  BRow, BCol, BLink, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue'
import authService from '@/vue.auth.service'
import store from '@/store/index'

const {
  appName, appTitle, appLogoImageUrl, appVersion,
} = $themeConfig.app

export default {
  components: {
    BRow, BCol, BLink, BCardText, BCardTitle, BImg, BForm, BButton,
  },
  data() {
    return {
      appName,
      appTitle,
      appLogoImageUrl,
      appVersion,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return require('@/assets/images/pages/login-v2-dark.svg')
      } return require('@/assets/images/pages/login-v2.svg')
    },
  },
  methods: {
    login(provider) {
      authService.redirectToLogin(provider)
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.auth-login-form img{
  height: 21px;
}
</style>
